module.exports = __webpack_public_path__ + "static/media/oy_1.e62e8d7b.mp3";